import { ProcessListItemDto, ProcessSearchRequestDto } from '@/api/generated';
import {
  processStatusOptionsTranslation,
  ProcessStatusTranslation,
} from '@/assets/locales/utils/dictionaries/dictionaries.translation.pl.ts';
import {
  processesCalendarEntryQueryTranslation,
  ProcessesCalendarEntryQueryTranslation,
} from '@/assets/locales/views/processes/calendarEntryQuery/processes.calendarEntryQuery.translation.pl.ts';

export type ProcessesTranslation = {
  calendarEntryQuery: ProcessesCalendarEntryQueryTranslation;
  header: {
    button: {
      add: string;
    };
  };
  table: {
    body: Record<keyof Omit<ProcessListItemDto, 'processId' | 'updatedAt'>, string> & {
      processStatusOptions: ProcessStatusTranslation;
    };
    head: Record<keyof Omit<ProcessSearchRequestDto, 'isNeedingAttention'>, string> & {
      processStatusOptions: ProcessStatusTranslation;
    };
  };
};

export const processesTranslation: ProcessesTranslation = {
  calendarEntryQuery: processesCalendarEntryQueryTranslation,
  header: {
    button: {
      add: 'Utwórz proces',
    },
  },
  table: {
    body: {
      createdAt: 'Data utworzenia',
      creator: 'Rozpoczęty przez',
      customer: 'Klient',
      name: 'Nazwa',
      owner: 'Właściciel',
      processStatusOptions: processStatusOptionsTranslation,
      status: 'Status',
    },
    head: {
      createdFrom: 'Rozpoczęty po',
      createdTo: 'Rozpoczęty przed',
      customerId: 'Klient',
      fullTextSearchInput: 'Wyszukaj',
      processContactId: 'Osoba do kontaktu',
      processCreatorId: 'Rozpoczęty przez',
      processOwnerId: 'Właściciel',
      processStatusOptions: processStatusOptionsTranslation,
      statuses: 'Statusy',
      updatedFrom: 'Ostatnia aktualizacja po',
      updatedTo: 'Ostatnia aktualizacja przed',
    },
  },
};
